<template>
	<v-row justify="center">
		<v-dialog v-model="isDialogShow" persistent max-width="460">
			<v-card>
				<v-card-title class="h6 justify-center">Konfirmasi</v-card-title>
				<v-card-text class="text-center">
					<!-- {{messages}} -->
					<div v-html="messages"></div>
					<span v-if="warning" class="red--text d-block font-italic font-size-10">{{ warning }}</span>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click.stop="hideConfirm">{{ closeText }}</v-btn>
					<v-btn v-if="!noconfirm" :color="colorUsed" :dark="supplier" depressed class="text-capitalize" @click.stop="confirm">{{ confirmText }}</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
export default {
	data () {
		return {
			isDialogShow: false,
			messages: '',
			warning: '',
			closeText: 'Batal',
			confirmText: 'Yakin'
		}
	},
	props: {
		noconfirm: Boolean,
		supplier: Boolean,
	},
	computed: {
		colorUsed() {
			if (this.supplier) {
				return 'cyan darken-2'
			} else {
				return 'primary'
			}
		}
	},
	methods: {
		hideConfirm() {
			this.isDialogShow = false
		},
		showConfirm() {
			this.isDialogShow = true
		},
		setMessage(val){
			this.messages = val
		},
		setWarning(val){
			this.warning = val
		},
		setConfirmText(val){
			this.confirmText = val
		},
		setCloseText(val){
			this.closeText = val
		},
		confirm() {
			this.$emit('action')
		}
	}
}
</script>